import { Intent, Tag } from '@blueprintjs/core'
import * as React from 'react'
import { toTitleCase } from '../../../../utils'
import { FulfillmentStatus } from '../../types'

export interface FulfillmentStatusTagProps {
  value: FulfillmentStatus
  shipmentsCount: number
}

const highlightMap = {
  [FulfillmentStatus.FULFILLED]: Intent.PRIMARY,
  [FulfillmentStatus.UNFULFILLED]: Intent.WARNING,
  [FulfillmentStatus.PACKSLIP_UNPRINTED]: Intent.NONE,
  [FulfillmentStatus.PARTIALLY_FULFILLED]: Intent.NONE
}

const FulfillmentStatusTag: React.FC<FulfillmentStatusTagProps> = props => {
  return (
    <Tag round minimal intent={highlightMap[props.value]}>
      {toTitleCase(props.value)}
    </Tag>
  )
}
export default FulfillmentStatusTag
